/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getWhatIfAnalysisFetchFeatures} from "../../../api/sensorApi";
import moment from "moment";

const useInitialData = (sensorID, start, end, latestPCRDate, setPositionAndMaterial) => {
    const [corrosionRateData, setCorrosionRateData] = useState(null);

    const fetchInitialData = async (selectedDate) => {

        const data1 = await getWhatIfAnalysisFetchFeatures({
            sensor_id: sensorID,
            selected_date: moment(selectedDate).format("YYYY-MM-DD"),
        });

        if (data1?.length > 0) {
            const removeTarget = data1.filter((obj) => {
                if (obj["target"] !== undefined) {
                    setCorrosionRateData(obj["target"]);
                    return false;
                }
                return true;
            });
            setPositionAndMaterial(data1, removeTarget);
        }
    };

    useEffect(() => {
        if (latestPCRDate) {
            fetchInitialData(latestPCRDate);
        }
    }, [sensorID, start, end, latestPCRDate, setPositionAndMaterial]);

    return { corrosionRateData, setCorrosionRateData, fetchInitialData };
};


export default useInitialData;